@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.ss-settings-modal {
  width: 460px;
}

.ss-settings-modal-body {
  padding: 16px 16px 32px;
  height: 100%;
}

.label {
  font-size: 12px;
}

.name-input {
  padding: 10px 0;
  width: 400px;
}

.loading-indicator {
  height: 100px;
}
